export type Tab<T extends string> = { value: T; label: string; count?: number };

/** Underlined tabs. Arrow-key navigation per the WAI-ARIA tabs pattern. */
export function Tabs<T extends string>({ tabs, value, onChange, label = "Sections" }: {
  tabs: Tab<T>[]; value: T; onChange: (v: T) => void; label?: string;
}) {
  const onKeyDown = (e: React.KeyboardEvent) => {
    const i = tabs.findIndex((t) => t.value === value);
    if (e.key === "ArrowRight") onChange(tabs[(i + 1) % tabs.length].value);
    if (e.key === "ArrowLeft") onChange(tabs[(i - 1 + tabs.length) % tabs.length].value);
    if (e.key === "Home") onChange(tabs[0].value);
    if (e.key === "End") onChange(tabs[tabs.length - 1].value);
  };
  return (
    <div className="tabs" role="tablist" aria-label={label} onKeyDown={onKeyDown}>
      {tabs.map((t) => (
        <button key={t.value} role="tab" className="tab"
                aria-selected={t.value === value}
                tabIndex={t.value === value ? 0 : -1}
                onClick={() => onChange(t.value)}>
          {t.label}
          {t.count !== undefined && <span className="num muted"> {t.count}</span>}
        </button>
      ))}
    </div>
  );
}
